import React from 'react'
import SideBar from '../Sidebar/SideBar'
import NavHorizontal from '../NavHorizontal/NavHorizontal'

const Home = props => {
    const { children } = props
    return (
        <>
            <NavHorizontal/>
            <SideBar/>
            {/*<PageContainer children={ children }/>*/}
        </>
    )
}

export default Home
